/**
 * Web shim for expo-blur.
 *
 * expo-blur's BlurView / ExperimentalBlurMethod are native-only on Expo.
 * On web we replicate the visual effect with CSS backdrop-filter.
 * `intensity` is an Expo-specific 0-100 value; we map it to ~0-20px blur.
 */

import React from 'react';
import { View } from 'react-native';

export const BlurView = ({
  children,
  style,
  intensity = 50,
  tint = 'default',
  experimentalBlurMethod: _ebm,
  ...rest
}) => {
  const blurPx = (intensity / 100) * 20;

  // Map Expo tint values to a background colour overlay.
  const tintColor = {
    light:       'rgba(255, 255, 255, 0.6)',
    dark:        'rgba(0,   0,   0,   0.6)',
    default:     'rgba(255, 255, 255, 0.4)',
    extraLight:  'rgba(255, 255, 255, 0.8)',
    prominent:   'rgba(255, 255, 255, 0.5)',
    systemMaterial: 'rgba(255, 255, 255, 0.5)',
  }[tint] || 'rgba(255, 255, 255, 0.4)';

  return React.createElement(
    View,
    {
      ...rest,
      style: [
        style,
        {
          backdropFilter:       `blur(${blurPx}px)`,
          WebkitBackdropFilter: `blur(${blurPx}px)`,
          backgroundColor: tintColor,
        },
      ],
    },
    children,
  );
};

export default BlurView;
